module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Rage to Live")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Shirley Anne Edwards")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Can a young woman reveal her traumatic past to the woman who wants her to release the bubbling rage inside… her rage to live?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("An act of violence tore Charlie’s existence, and her family, apart. In an effort to reclaim something like the life she enjoyed before, Charlie moves in with relatives in a different state.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Charlie might be damaged, but she isn’t going down without a fight. With the help of her cousins, who attend the local college, she steels herself to repeat her final year of high school. On the university campus, she meets Arielle Forest, president of a popular sorority, daughter of the dean, and bisexual. Charlie is drawn to Arielle’s sunny outlook, but she can’t banish her doubts as romance blossoms. Does Arielle know what she’s getting into with Charlie and her unhealed wounds? Will she want to deal with the complications?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Charlie’s past catches up to her, will she find the strength to keep fighting… or succumb to the call to escape all her pain for good?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0